<div *ngIf="!loading && communityPrograms.length === 0">
    <div style="color: rgba(0, 0, 0, 0.6);">
        <span>{{ 'NO-PINNED-RESOURCES' | translate}}</span>
    </div>
</div>
<div *ngIf="!loading && communityPrograms.length > 0" class="mt-4">
    <div class="card mb-1 w-100" *ngFor="let program of communityPrograms">
        <div class="card-body card-body-smaller">
            <div class="row">
                <div class="col-2 pl-0" style="max-width:55px;margin-right:-5px;">
                    <i class="fas fa-fw fa-trash-alt" title="{{'DELETE' | translate}}"
                        (click)="deletePinnedResource(program)" role="button" attr.aria-label="{{'DELETE' | translate}}"
                        tabindex="0" (keydown.enter)="deletePinnedResource(program)"
                        (keydown.space)="deletePinnedResource(program)">
                    </i>
                    <span style="display: inline-flex" *ngIf="program.pinnedBy" class="ml-1">
                        <div kendoTooltip position="top" [tooltipTemplate]="programTimestampTemplate"
                            class="keyboard-accessible" tabindex="0" showOn="none" aria-live="polite"
                            (focus)="showTooltip(timestampTooltip)" (mouseover)="showTooltip(timestampTooltip)"
                            (blur)="hideTooltip()" (mouseout)="hideTooltip()">
                            <i #timestampTooltip title="" class="fa fa-info-circle pointer"></i>
                            <ng-template #programTimestampTemplate>
                                <span>
                                    {{'ADDED-BY-TIMESTAMP' |
                                    translate}}&nbsp;<strong>{{program.pinnedBy}}</strong>&nbsp;{{'TIMESTAMP-ON' |
                                    translate}}&nbsp;<strong>{{intl.formatDate(intl.parseDate(program.pinnedOn),'g')}}</strong>
                                </span>
                            </ng-template>
                        </div>
                    </span>
                </div>
                <div class="col-10 pl-0">
                    <a class="pointer" (click)="showProgram(program)" tabindex="0"
                        (keydown.enter)="showProgram(program)"
                        (keydown.space)="showProgram(program)">{{program.name}}</a>
                </div>
            </div>
        </div>
    </div>
</div>

<kendo-dialog *ngIf="deletePinnedServiceDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
    (close)="closePinnedServiceDialog()">
    <p>{{'CONFIRM-DELETION-PINNED-SERVICE' | translate}}</p>
    <span class="k-font-weight-bold">{{selectedServiceName}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="closePinnedServiceDialog()">{{'NO' | translate}}</button>
        <button appPreventClick kendoButton (click)="deletePinnedService()">{{'YES' | translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>

<div class="k-overlay" *ngIf="programOpened"></div>
<app-community-service-info *ngIf="programOpened" [memberId]="memberId" [programIds]="[programId]"
    (cancelling)="closeProgramDialog()">
</app-community-service-info>